import styled from '@emotion/styled';
import FixedBottomBarBase from '@portalterreno/react-ui-core/FixedBottomBar';

const FixedBottomBar = styled(FixedBottomBarBase)({
  padding: '25px 15px',
  margin: 0,
  zIndex: 99
});

export default FixedBottomBar;
